// extracted by mini-css-extract-plugin
export default {"text":"personalizedDropDown_text__-KyxZ"};